import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded } from '../../../../layout/redux/layoutActions'

export const PRIORITIES_FETCH_REQUEST = 'PRIORITIES_FETCH_REQUEST'
export const PRIORITIES_FETCH_SUCCESS = 'PRIORITIES_FETCH_SUCCESS'
export const PRIORITIES_FETCH_FAILURE = 'PRIORITIES_FETCH_FAILURE'
export const PRIORITIES_CLEAR = 'PRIORITIES_CLEAR'

const normalizarItens = grupos => {
  if (!Array.isArray(grupos)) {
    return []
  }

  return grupos.reduce((acc, grupo) => {
    const itens = Array.isArray(grupo.itens) ? grupo.itens : []

    const itensNormalizados = itens.map(item => ({
      ...item,
      grupoCodigo: grupo.codigo,
      grupoTitulo: grupo.titulo
    }))

    return [...acc, ...itensNormalizados]
  }, [])
}

export const fetchPriorities = projetoId => {
  return async dispatch => {
    dispatch({ type: PRIORITIES_FETCH_REQUEST })
    dispatch(loading())

    try {
      const response = await apiPdca.get('/pdca/planos/prioridades', {
        params: {
          projetoId,
          limit: 20
        }
      })

      const data = response?.data

      if (!data || data.ok !== true) {
        throw new Error('Erro ao carregar prioridades.')
      }

      const grupos = Array.isArray(data.grupos) ? data.grupos : []
      const itens = normalizarItens(grupos)

      dispatch({
        type: PRIORITIES_FETCH_SUCCESS,
        payload: {
          projetoId: data.projetoId,
          limite: data.limite,
          grupos,
          itens,
          total: itens.length
        }
      })
    } catch (error) {
      dispatch({
        type: PRIORITIES_FETCH_FAILURE,
        payload: error?.message || 'Erro ao carregar prioridades.'
      })
    } finally {
      dispatch(loaded())
    }
  }
}

export const clearPriorities = () => ({
  type: PRIORITIES_CLEAR
})